/* ===== dtc-bundle-offers.js ===== */
class DtcBundleOffers {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.options = Array.from(root.querySelectorAll('[data-dtc-bundle-option]'));
    this.productInfo = root.closest('product-info') || document;
    this.init();
  }

  init() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => this.select(option));
    });

    const selected = this.root.querySelector('[data-dtc-bundle-option].is-selected') || this.options[0];
    if (selected) this.select(selected, false);
  }

  select(option, focus = true) {
    this.options.forEach((item) => {
      const isSelected = item === option;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    const quantity = parseInt(option.dataset.quantity || '1', 10);
    this.updateQuantity(quantity);

    if (focus) option.focus({ preventScroll: true });
  }

  updateQuantity(quantity) {
    if (!quantity || quantity < 1) quantity = 1;

    const selectors = [
      `#Quantity-${this.sectionId}`,
      `input[name="quantity"][form="product-form-${this.sectionId}"]`,
      `quantity-input input[name="quantity"]`,
      `input[name="quantity"]`
    ];

    let input = null;
    for (const selector of selectors) {
      input = this.productInfo.querySelector(selector) || document.querySelector(selector);
      if (input) break;
    }

    if (input) {
      input.value = quantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    const form = document.querySelector(`#product-form-${this.sectionId}`) || this.productInfo.querySelector('form[action*="/cart/add"]');
    if (form) {
      let hiddenQty = form.querySelector('input[name="quantity"]');
      if (!hiddenQty) {
        hiddenQty = document.createElement('input');
        hiddenQty.type = 'hidden';
        hiddenQty.name = 'quantity';
        form.appendChild(hiddenQty);
      }
      hiddenQty.value = quantity;
    }
  }
}

function initDtcBundleOffers() {
  document.querySelectorAll('[data-dtc-bundle-offers]:not([data-dtc-bundle-initialized])').forEach((root) => {
    root.dataset.dtcBundleInitialized = 'true';
    new DtcBundleOffers(root);
  });
}

document.addEventListener('DOMContentLoaded', initDtcBundleOffers);
document.addEventListener('shopify:section:load', initDtcBundleOffers);


/* ===== dtc-v2.js ===== */
function initDtcBeforeAfter() {
  document.querySelectorAll('[data-dtc-before-after]:not([data-dtc-ba-ready])').forEach((slider) => {
    slider.dataset.dtcBaReady = 'true';
    const range = slider.querySelector('.dtc-before-after__range');
    const after = slider.querySelector('.dtc-before-after__after');
    const handle = slider.querySelector('.dtc-before-after__handle');
    if (!range || !after || !handle) return;

    const update = () => {
      const value = range.value;
      after.style.width = value + '%';
      handle.style.left = value + '%';
    };

    range.addEventListener('input', update);
    update();
  });
}

document.addEventListener('DOMContentLoaded', initDtcBeforeAfter);
document.addEventListener('shopify:section:load', initDtcBeforeAfter);
